import React from 'react'
import clsx from "clsx";
import {
    Container,
    UnderlineTextButton,
    PrimaryButton,
    DeleteButton,
} from "./FullscreenModal.styles";
import TopBarRedesigned from "../TopBarRedesigned/TopBarRedesigned";

interface GreenCheckmarkWithTextProps {
    isOpen: boolean,
    isNoBackArrow?: boolean,
    title: string,
    buttonText?: string,
    children?: React.ReactNode,
    onClose: () => void,
    onSubmit: (e: any) => void,
    onDelete?: () => void,
    submitRef?: any,
    stickyBottom?: boolean,
    disabledSubmit?: boolean,
    underlinedButtonText?: string,
    deleteButtonText?: string,
    isSignUpPage?: boolean
}

const FullscreenModal = ({title, buttonText, children, onClose, onSubmit, isOpen, isNoBackArrow=false, submitRef, stickyBottom = true, disabledSubmit, underlinedButtonText, deleteButtonText, onDelete, isSignUpPage=false}: GreenCheckmarkWithTextProps) => {
    return (
        <Container
            id="fsModal"
            style={{display: isOpen ? 'flex' : 'none'}}
            onSubmit={onSubmit}
            isSignUpPage={isSignUpPage}
        >
            <TopBarRedesigned isNoBackArrow={isNoBackArrow} onBack={onClose} title={title} />
            <div className={clsx('modalBody', stickyBottom ? 'marginBody' : '' )}>{children}</div>
            <div className={clsx('modalFooter', stickyBottom ? 'stickyBottom' : '')}>
                {buttonText && <PrimaryButton
                    disabled={disabledSubmit}
                    ref={submitRef}
                    type={"submit"}
                    variant="contained"
                    color="primary"
                    size="large"
                    id="signup-button"
                    className="submitButton"
                >
                    {buttonText}
                </PrimaryButton>}
                {deleteButtonText && <DeleteButton
                    variant="outlined"
                    color="primary"
                    size="small"
                    id="signup-button"
                    onClick={onDelete}
                >
                    {deleteButtonText}
                </DeleteButton>}
                {underlinedButtonText && <UnderlineTextButton
                    className={'onCloseBtn'}
                    variant="text"
                    color="primary"
                    size="large"
                    onClick={onClose}
                >
                    {underlinedButtonText}
                </UnderlineTextButton>}
            </div>
        </Container>
    )
}

export default FullscreenModal
